import { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { check } from '../../../utils/tokenUtils';
import { getNavigationBackground } from '../../../actions/navigation-background';
import { getLatestNews } from '../../../actions/latest-news';
import { getAdminLinks } from '../../../actions/adminLinks';
import NavbarTopLinks from './navbar-top-links';
import NavbarMainMenu from './navbar-main-menu';
import { Menu, MenuSelect, Cancel, CancelSelect } from '../../common/icons';
import IgniteUkLogo from '../../../assets/img/ignite_logo_black.png';
import IgniteUkLogoGold from '../../../assets/img/ignite_logo_gold.png';
import IgniteUkLogoSelect from '../../../assets/img/ignite_logo_select_2.png';

import './user-navigation.css';

class UserNavigation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menu: false
    };
  }

  handleMenu = () => {
    this.setState({
      menu: !this.state.menu
    });
  }

  componentDidMount = () => {
    const { dispatch } = this.props;

    dispatch(getNavigationBackground());
    dispatch(getLatestNews());
    dispatch(getAdminLinks());
  }

  selectLogo = () => {
    const { gold, hasSelectTheme } = this.props;

    if (gold) {
      return IgniteUkLogoGold;
    }

    if (hasSelectTheme) {
      return IgniteUkLogoSelect;
    }

    return IgniteUkLogo;
  };

  selectMenu = (menuIconClassName) => {
    const { hasSelectTheme } = this.props;

    if (hasSelectTheme) {
      return <MenuSelect height={24} width={24} onClick={() => this.handleMenu()} />;
    }

    return <Menu height={24} width={24} className={menuIconClassName} onClick={() => this.handleMenu()} />;
  }

  selectCancel = (menuIconClassName) => {
    const { hasSelectTheme } = this.props;

    if (hasSelectTheme) {
      return <CancelSelect height={24} width={24} onClick={() => this.handleMenu()} />;
    }

    return <Cancel height={24} width={24} className={menuIconClassName} onClick={() => this.handleMenu()} />;
  }

  selectBackgroundImage = () => {
    const {
      hasSelectTheme,
      postlogin,
      prelogin,
      postLoginMiniChains
    } = this.props;

    if (check()) {
      if (hasSelectTheme) {
        return postLoginMiniChains;
      }

      return postlogin;
    }

    return prelogin;
  }

  render() {
    const {
      gold,
      hasSelectTheme
    } = this.props;
    const { menu } = this.state;
    const menuIconClassName = gold ? 'navbar-menu navbar-menu-gold' : 'navbar-menu';

    return (
      <nav className="navbar fixed-top">
        <div className="container-fluid">
          <Link to='/'>
            <img src={this.selectLogo()} alt="Ignite UK" />
          </Link>
          <div className="navbar-right">
            <div className="nav-desktop-menu-links">
              <NavbarTopLinks gold={gold} hasSelectTheme={hasSelectTheme} search={this.state.search} handleInputChange={this.handleInputChange} />
            </div>
            {this.state.menu ? (
              this.selectCancel(menuIconClassName)
            ) : (
              this.selectMenu(menuIconClassName)
            )}
          </div>
          {menu && (
            <div className="navigation-menu-active" style={{ backgroundImage: `url(${this.selectBackgroundImage()})` }}>
              <div className="nav-mobile-menu-links">
                <NavbarTopLinks gold={gold} hasSelectTheme={hasSelectTheme} />
              </div>
              <NavbarMainMenu handleMenu={this.handleMenu} />
            </div>
          )}
        </div>
      </nav>
    );
  }
}

const mapStateToProps = state => ({
  prelogin: state.navigationBackground.prelogin,
  postlogin: state.navigationBackground.postlogin,
  postLoginMiniChains: state.navigationBackground.post_login_mini_chains,
  hasSelectTheme: state.viewConfig.profile.attributes['has-mini-chain-outlet']
});

export default connect(mapStateToProps)(UserNavigation);
